import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode disabled because react-leaflet 4.x re-initializes MapContainer
// twice in dev mode, breaking the map.
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
